module.exports = __webpack_public_path__ + "img/bg_city_street.311fe793.jpg";